import React from 'react';
import { RetirementCalculatorSavingsStepPropsModel } from '../../tools/RetirementCalculator.model';
import { RetirementCalculatorSavings } from '../RetirementCalculatorSavings/RetirementCalculatorSavings';
import { RetirementCalculatorResult } from '../RetirementCalculatorResult/RetirementCalculatorResult';
import { RetirementCalculatorLayout } from '../RetirementCalculatorLayout/RetirementCalculatorLayout';
import { useRetirementCalculatorLayout } from '../RetirementCalculatorLayout/RetirementCalculatorLayout.context';

import useLayoutStyles from '../RetirementCalculatorLayout/RetirementCalculatorLayout.style';

export const RetirementCalculatorSavingsStep: React.FC<RetirementCalculatorSavingsStepPropsModel> = ({
  title,
  submitLabel,
  initialValues,
  yearlyContributionLimits,
  projection,
  onSubmit,
  onValuesChange,
  disabled,
  isLoading,
}) => {
  const c = useLayoutStyles({});
  const { titleId } = useRetirementCalculatorLayout();

  return (
    <RetirementCalculatorLayout>
      <RetirementCalculatorSavings
        className={c.formColumn}
        titleId={titleId}
        title={title}
        submitLabel={submitLabel}
        initialValues={initialValues}
        yearlyContributionLimits={yearlyContributionLimits}
        onSubmit={onSubmit}
        onValuesChange={onValuesChange}
        disabled={disabled}
        isLoading={isLoading}
      />
      <RetirementCalculatorResult className={c.previewColumn} projection={projection} />
    </RetirementCalculatorLayout>
  );
};
